import { render, staticRenderFns } from "./labelEdit.vue?vue&type=template&id=6aa648b0&scoped=true&"
import script from "./labelEdit.vue?vue&type=script&lang=js&"
export * from "./labelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa648b0",
  null
  
)

export default component.exports